/* eslint-disable */
import React, {createContext, useContext, useMemo} from 'react';
import {ApolloClient} from '@apollo/client';
import {NormalizedCacheObject} from '@apollo/client/cache';
import ErrorBoundary from '../../ErrorBoundary';
import createDirectConnectClient from './createDirectConnectClient';

export type CaptureExceptionMethod = (
  exception: any,
  captureContext?: any // additional info about the event. Full Sentry type can be found here: https://github.com/getsentry/sentry-javascript/blob/e59bb030198f20c5208ece66c1f46ed6b6410fd4/packages/types/src/scope.ts
) => string;

interface Props {
  children: React.ReactNode;
  client?: ApolloClient<NormalizedCacheObject>;
  captureException?: CaptureExceptionMethod;
}

const DirectConnectContext = createContext<ApolloClient<NormalizedCacheObject> | undefined>(
  undefined
);

export const SentryContext = createContext<CaptureExceptionMethod | undefined>(undefined);

function DirectConnectProvider({client, captureException, children}: Props) {
  const providerClient = useMemo(() => client || createDirectConnectClient(), [client]);

  return (
    <SentryContext.Provider value={captureException}>
      <ErrorBoundary>
        <DirectConnectContext.Provider value={providerClient}>
          {children}
        </DirectConnectContext.Provider>
      </ErrorBoundary>
    </SentryContext.Provider>
  );
}

export default DirectConnectProvider;

export const useCaptureException = () => useContext(SentryContext);
export const useDirectConnectClient = () => useContext(DirectConnectContext);
